import { Icp } from '../../utils/icp.util';

export interface BrandCopy {
  /** Small line that tells the right visitor they are in the right place. */
  eyebrow?: string;
  lead: string;
  accent: string;
  /** Short lines; "\n" starts a new line. */
  sub: string;
}

/**
 * Signup headline per buyer. Each variant mirrors the page or ad the visitor came from, so the words
 * they clicked on are the words they land on. Keep this to a handful of audience-based angles, not one per ad.
 */
export const SIGNUP_COPY: { [key in Icp]: BrandCopy } = {
  // Founder pain in plain English (the shared promise), for visitors we know nothing else about
  default: {
    eyebrow: 'For teams of 15–100 people',
    lead: "Know what's happening",
    accent: 'without asking everyone.',
    sub: "Open the day. Ask once.\nTry it on your own computer first. Add your team when you're ready."
  },
  // Mirrors the agency Meta ad that brought in 4 signups
  agency: {
    eyebrow: 'Digital agencies · 15–100 people',
    lead: 'See yesterday',
    accent: 'before you promise one more option.',
    sub: "Open yesterday's workday and answer the client with clearer context."
  },
  it: {
    eyebrow: 'IT services · 15–100 people',
    lead: 'The standup said it was ready.',
    accent: 'The Friday demo still slipped.',
    sub: "Stop chasing status. Follow up earlier when the workday doesn't match the update."
  },
  bpo: {
    eyebrow: 'For BPO & support operations',
    lead: 'Your BPO floor.',
    accent: 'One live view.',
    sub: 'See which desks need help, then open one screen and coach in the shift.'
  },
  // Mirrors the "Kya Status Hai" Meta ad that brought in 7 signups, word for word
  status: {
    eyebrow: 'IT founders · 15–100 employees',
    lead: 'You don\'t want to be that founder who asks "kya status hai?"',
    accent: '10 times a day.',
    sub: 'You trusted them at 5. You still trust them at 30 and 50.\nYou just need awareness, not surveillance.\nOpen the day. Ask once.'
  }
};

export function getBrandCopy(icp: Icp): BrandCopy {
  return SIGNUP_COPY[icp] || SIGNUP_COPY.default;
}
